import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MaterialOrderWithNotes} from '../material-order.model';
import {EnvisiaLocation} from '../../../../common/location/envisia-location';
import {Lister} from '../../../../common/wrapper.models';
import {ListService} from '../../../../common/search/search.service';
import {environment} from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialOrderListService implements ListService<MaterialOrderWithNotes> {
  constructor(protected http: HttpClient) {
  }

  list(query?: any): Observable<Lister<MaterialOrderWithNotes>> {
    return this.http.get<Lister<MaterialOrderWithNotes>>(
      environment.apiv4uri + 'material/order/list',
      {params: EnvisiaLocation.httpParams(query)}
    );
  }
}
